module.exports = __webpack_public_path__ + "img/Jc.7cd6c702.png";